import React from "react";
import { Link } from 'react-router-dom';
import clsx from "clsx";

const LandingHeader = ({ history, fullWidth = false }) => {

  return (
    <header className={clsx("landing-header", { 'landing-header--full': fullWidth })}>
      <div className={clsx('header-container', { 'header-container--full': fullWidth })}>
        <Link to="/"><div className="logo"></div></Link>
        <nav className="header-nav-links">
          <Link to="/about">About</Link>
          <Link to="/tos">TOS</Link>
          <Link to="/help">Help</Link>
          <a href="https://oldhamlab.ucsf.edu/" target="_blank" rel="noopener noreferrer" style={{width: '105px'}}>Oldham Lab</a>
        </nav>
      </div>
    </header>
  );
};

export default LandingHeader;
